import type { PromptModelConfigCreate } from '~/api/sylvanus/typedefs.autogen';

import { sylvanus } from '~/services/serviceInstances';

import {
  type DdeModelCreateResult,
  mapDdeModelCreateResult,
  type ServerDdeModelCreateRequest,
  type ServerDdeModelCreateResult,
} from './ddeModelTypes';

type CreateDdeModelRequest = {
  configuration?: PromptModelConfigCreate | null;
  modelName: string;
  promptModelId?: string | null;
  tableId: string;
};

const mapRequest = ({
  configuration,
  modelName,
  promptModelId,
}: Omit<CreateDdeModelRequest, 'tableId'>): ServerDdeModelCreateRequest => ({
  model_name: modelName,
  ...(promptModelId ? { prompt_model_id: promptModelId } : {}),
  ...(configuration ? { configuration } : {}),
});

export const createDdeModel = async ({
  configuration,
  modelName,
  promptModelId,
  tableId,
}: CreateDdeModelRequest): Promise<DdeModelCreateResult> => {
  const response = await sylvanus.post<ServerDdeModelCreateResult>(
    `/dde/table/${tableId}/model`,
    mapRequest({ configuration, modelName, promptModelId }),
  );

  return mapDdeModelCreateResult(response);
};
